<script lang="ts" setup>
import {  onMounted, reactive, ref } from 'vue';
import { LoadingSection } from '../../LibMain';
import { ISentinelApiKey } from '../../lib/Api/Sentinel';
import ChoiceTable from "../ChoiceTable.vue"
import { ICol } from '../../lib/ChoiceTableHelpers';
import {  useRouter } from 'vue-router'
import { initPinia } from '../../lib/PiniaMgr';
import { useSentinelStore } from '../../lib/Stores/SentinelStore';

interface IBaseKeys{
  keyList: ISentinelApiKey[]
}

const router = useRouter();

const sentinelStore = useSentinelStore(initPinia());

const base = reactive<IBaseKeys>({
  keyList:[]
});

const windowHeight = ref<number>();

onMounted(async() => {
  windowHeight.value = window.innerHeight;
  window.addEventListener('resize', () => {
            windowHeight.value = window.innerHeight
        });
  sentinelStore.getKeys();
})

async function onClickRefresh(){
  sentinelStore.refreshKeysAndMap();
}

function newGenerateKey(){
  router.push({name:'NewKey',path:'/newkey'})
}

const tableColumns = ref<ICol[]>([
    { Name: 'ID', DataField: 'sentinelApiKeyID' },
    { Name: 'Description', DataField: 'sentinelKeyDescription'},
    { Name: 'Key', DataField: 'sentinelApiKey' , HideFilter: true},
    { Name: 'isActive', DataField: 'isActive' , HideFilter: true},
    { Name: 'Details', DataField: undefined, HideFilter: true}
  ]);
</script>
<template>
  <div class="row mt-2">
    <div class="col">
      <div class="btn-group" role="toolbar" aria-label="Cool ToolBar Collection">
        <button class="btn btn-primary btn-sm btn-key" @click="onClickRefresh()">
          Refresh Key List
        </button>
        <button class="btn btn-primary btn-sm btn-key" @click=newGenerateKey()>
          Generate New Key
        </button>
      </div>
    </div>
  </div>
  <div>
    <LoadingSection :isLoading="!sentinelStore.keys" loadingMsg="Getting Keys">

      <ChoiceTable
      :data="sentinelStore.keys"
      :columns="tableColumns"
      :height="windowHeight"
      :show-filters="true" 
      :allowSorting="true"
      :key-value-data-member="'ID'"
      >
        <template #cell="{col,row,value}">
          <td> {{ value }} </td>
          <td v-if="value === undefined">
            <RouterLink :to="{ 
              path:'/Key', 
              params: {id:row.sentinelApiKeyID}, 
              name:'KeyDetails'
              }">
              <button class="btn btn-primary btn-sm">
                Edit
              </button>
            </RouterLink>
          </td>
        </template>
      </ChoiceTable>
    </LoadingSection>
  </div>
</template>
<style>
.btn-key {
  margin-top: 10px;
  margin-bottom: 10px;
  margin-right: 5px;
}
</style>